import { Outlet } from 'react-router-dom'

const AppContainer = () => <Outlet />

export default AppContainer
